export default [

     {
          path: '/warning-potential-impact-matrix',
          name: 'WarningPotentialImpactMatrix',
          component: () => import("@/views/Page/WarningPotentialImpactMatrix/WarningPotentialImpactMatrix.vue"),
          meta: {
               title: 'Warning Potential Impact Matrix',
          },
     }
];